import React from 'react';
import Badge from './Badge';

const BadgeField = ({ value, data }) => <Badge>{value}</Badge>;

export { BadgeField };
